import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { useFolders } from "~/client/services/data/folders/hooks";
interface WorkspaceHeaderProps {
  readonly folderId?: string;
}
export const WorkspaceHeader: FC<WorkspaceHeaderProps> = t0 => {
  const $ = _c(7);
  const {
    folderId
  } = t0;
  let t1;
  if ($[0] !== folderId) {
    t1 = {
      id: folderId
    };
    $[0] = folderId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    entity: folder
  } = useFolders(t1);
  const t2 = folder ? folder.title : "My Workspace";
  let t3;
  if ($[2] !== t2) {
    t3 = <div><h1 className="workspace__title">{t2}</h1></div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <header className="workspace__header">{t3}{t4}</header>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export const WorkspaceHeaderFallback: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <header className="workspace__header"><div><h1 className="workspace__title">My Workspace</h1></div><div><div className="workspace__filters" /></div></header>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};